module.exports = "<span ng-if=!isMobile> <div class=\"kids404 style404\"> <span class=brownRectLeft></span> <span class=brownRectRight></span> </div> </span> <div ng-if=isMobile class=MobileContainer404 style=top:30px> <img src=" + require("../../img/404-mobile-kids.png") + " class=404Mobile> </div>\t";


//////////////////
// WEBPACK FOOTER
// ./public/kids/views/404.html
// module id = 145
// module chunks = 0